/**
 * @author Fernando Ruano
 * @file en.js
 * @description English translations
 */

// Translations
import login from '@nephro/pages/Login/messages';
import components from '@nephro/pages/ComponentsState/messages';
import patientRecords from '@nephro/pages/PatientRecords/messages';
import registration from '@nephro/pages/PatientRegistration/messages';
import passwordRecovery from '@nephro/pages/PasswordRecovery/messages';
import patientManagement from '@nephro/pages/Patients/PatientManagement/messages';
import DashboardDetail from '@nephro/pages/DashboardDetail/messages';
import calendarManagement from '@nephro/pages/MyAppointments/messages';
import roleManagement from '@nephro/pages/Roles/RolesManagement/messages';
import profileManagement from '@nephro/pages/Profiles/ProfilesManagement/messages';
import paramManagement from '@nephro/pages/Parameters/ParametersManagement/messages';
import countryUserRoleManagement from '@nephro/pages/CountryUserRoles/CountryUserRolesManagement/messages';
import dashboard from '@nephro/containers/Dashboard/messages';
import pageHeader from '@nephro/components/PageHeader/messages';
import commons from '@nephro/commons/messages';
import errors from '@nephro/commons/messagesError';
import previewDocuments from '@nephro/components/PreviewDocuments/messages';
import indicators from '@nephro/pages/Indicators/messages';
import dashboardPatient from '@nephro/pages/DashboardPatient/messages';
import educationalMaterial from '@nephro/pages/EducationalMaterial/messages';
import patientEvents from '@nephro/pages/PatientEvents/messages';
import termsAndConditions from '@nephro/pages/About/TermsAndConditions/messages';
import about from '@nephro/pages/About/messages';
import dashboardStaff from '@nephro/pages/DashboardStaff/messages';

export default {
  login: { ...login.en },
  dashboardStaff: { ...dashboardStaff.en },
  components: { ...components.en },
  dashboard: { ...dashboard.en },
  commons: { ...commons.en },
  errors: { ...errors.en },
  patientMg: { ...patientManagement.en },
  roleMg: { ...roleManagement.en },
  paramMg: { ...paramManagement.en },
  calendarMg: { ...calendarManagement.en },
  curMg: { ...countryUserRoleManagement.en },
  profileMg: { ...profileManagement.en },
  pageHeader: { ...pageHeader.en },
  registration: { ...registration.en },
  previewDocuments: { ...previewDocuments.en },
  passwordRecovery: { ...passwordRecovery.en },
  dashboardDet: { ...DashboardDetail.en },
  indicators: { ...indicators.en },
  dashboardPatient: { ...dashboardPatient.en },
  patientRecords: { ...patientRecords.en },
  educationalMaterial: { ...educationalMaterial.en },
  patientEvents: { ...patientEvents.en },
  termsAndConditions: { ...termsAndConditions.en },
  about: { ...about.en }
};
